import React from 'react';
import PropTypes from 'prop-types';
import Transition from '@clearscore/rainbow.transition';
import useTimeout from '@clearscore/hooks.use-timeout';
import Portal from '@clearscore/helpers.portal';
import Text from '@clearscore/rainbow.text';

import styles from './notification.controller.css';
import { themes } from '../constants';
import Notification from '../notification';

const animStates = {
    enter: {
        transition: 'opacity 100ms ease-out, transform 100ms ease-in',
        opacity: 1,
        transform: 'translateY(0) scale(1)',
    },
    exit: {
        transition: 'opacity 100ms ease-out, transform 100ms ease-in',
        opacity: 0,
        transform: 'translateY(-15%) scale(0.95)',
    },
};

const NotificationController = ({ dataId, isOpen, children, onDismiss, duration, onTransitionEnd, ...props }) => {
    useTimeout(onDismiss, duration);
    return (
        <Portal className={styles.containerWrapper}>
            <Transition states={animStates} isEnterState={isOpen} unmountOnExit onTransitionEnd={onTransitionEnd}>
                <div data-qa="notification-controller" data-id={dataId}>
                    <Notification {...{ ...props, onDismiss }}>
                        <Text {...Text.presets.BODY2}>{children}</Text>
                    </Notification>
                </div>
            </Transition>
        </Portal>
    );
};

NotificationController.propTypes = {
    duration: PropTypes.number,
    isOpen: PropTypes.bool,
    dataId: PropTypes.string,

    children: PropTypes.node.isRequired,
    theme: PropTypes.oneOf(Object.values(themes)),
    title: PropTypes.string,
    ctaText: PropTypes.string,
    ctaHandler: PropTypes.func,
    onDismiss: PropTypes.func,
    onTransitionEnd: PropTypes.func,
};

NotificationController.defaultProps = {
    duration: null,
    isOpen: false,
    dataId: '',

    theme: themes.INFO,
    ctaText: '',
    ctaHandler: null,
    title: '',
    onDismiss: null,
    onTransitionEnd: null,
};

export default NotificationController;
